import axiosClient from './axiosClient';

// ============================================================
// Base de l'API — équivalent de API_BASE_URL côté PHP
// Doit être défini dans le .env du back-office React :
//   REACT_APP_API_BASE_URL=https://maya-importexport.com/cere-gabon/api
// ============================================================
const API_BASE_URL = (
  'https://maya-importexport.com/cere-gabon/api'
).replace(/\/+$/, '');

// ============================================================
// Helpers — équivalents React de view_url() et download_url()
// ============================================================

/** URL d'aperçu inline : /api/documents/{slug}/view */
export function viewUrl(slug) {
  if (!slug) return null;
  return `${API_BASE_URL}/documents/${encodeURIComponent(slug)}/view`;
}

/** URL de téléchargement : /api/documents/{slug}/download */
export function downloadUrl(slug) {
  if (!slug) return null;
  return `${API_BASE_URL}/documents/${encodeURIComponent(slug)}/download`;
}

// ============================================================
// Client API documents
// ============================================================
export const documentsApi = {
  list: async (params = {}) => {
    const { data } = await axiosClient.get('/documents', { params });
    return data.data;
  },

  get: async (idOrSlug) => {
    const { data } = await axiosClient.get(`/documents/${idOrSlug}`);
    return data.data;
  },

  create: async (payload) => {
    const { data } = await axiosClient.post('/admin/documents', payload);
    return data.data;
  },

  update: async (id, payload) => {
    const { data } = await axiosClient.put(`/admin/documents/${id}`, payload);
    return data.data;
  },

  destroy: async (id) => {
    const { data } = await axiosClient.delete(`/admin/documents/${id}`);
    return data.data;
  },

  uploadFile: async (id, file) => {
    const formData = new FormData();
    formData.append('file', file);
    const { data } = await axiosClient.post(
      `/admin/documents/${id}/file`,
      formData,
      { headers: { 'Content-Type': 'multipart/form-data' } }
    );
    return data.data;
  },
};